// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"173":"74ff2d2c","284":"7b1b4ba9","493":"e73f9b7b","586":"253397b4","604":"1f930e69","861":"0f85575b","914":"e2937533","964":"f57430cd"}[chunkId] + ".js";
};